import React, { useMemo } from 'react';
import { DBO_V } from '@op/utils/format';
import './RatioBar.scss';

interface RatioBarProps {
  /** 当前值 */
  value: number;
  /** 最大值（用于计算比例） */
  max: number;
  /** 类型：默认为灰色，positive 为绿色，negative 为红色 */
  type?: 'default' | 'positive' | 'negative';

  format?: (value: number) => string;
}

/**
 * 色块比例条组件
 * @description 用于表格中展示数值的比例可视化，如评论数、推荐数等
 */
const RatioBar: React.FC<RatioBarProps> = ({ value, max, format = DBO_V.reviews }) => {
  const percentage = useMemo(() => {
    if (
      value == null ||
      isNaN(value) ||
      max == null ||
      isNaN(max) ||
      max <= 0
    ) {
      return 0;
    }
    const ratio = value / max;
    return Math.min(ratio, 1) * 100;
  }, [value, max]);

  const displayValue =
    value !== null && !isNaN(value) ? format(value) : '-';

  return (
    <div className="dbo-ratio-bar__container">
      <div className="dbo-ratio-bar">
        <div
          className="dbo-ratio-bar__percentage"
          style={{
            width: `${percentage}%`,
          }}
        ></div>
        <div className="dbo-ratio-bar__value">{displayValue}</div>
      </div>
    </div>
  );
};

export default React.memo(RatioBar);
